import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const HeaderWrapper = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: background-color 0.3s ease;
`;

const NavLink = styled(Link)`
  color: ${({ theme }) => theme.colors.text};
  padding: 0 20px;
  font-weight: 500;
  font-size: 1rem;
  transition: color 0.3s ease;
  
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const LogoWrapper = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const LogoImage = styled.img`
  height: 50px; /* Adjust this according to your logo size */
  cursor: pointer;
`;

const Nav = styled.nav`
  ul {
    display: flex;
    list-style: none;
    gap: 20px;
  }

  li {
    font-size: ${({ theme }) => theme.fontSizes.medium};
  }
`;

const Header = () => (
  <HeaderWrapper>
    <LogoWrapper to="/">
      <LogoImage src="/assets/logo.png" alt="Cloudetica Solutions Logo" />
    </LogoWrapper>
    <Nav>
      <ul>
        <li><NavLink to="/">Home</NavLink></li>
        <li><NavLink to="/about">About</NavLink></li>
        <li><NavLink to="/services">Services</NavLink></li>
        <li><NavLink to="/case-studies">Case Studies</NavLink></li>
        <li><NavLink to="/blog">Blog</NavLink></li>
        <li><NavLink to="/contact">Contact</NavLink></li>
      </ul>
    </Nav>
  </HeaderWrapper>
);

export default Header;
